import { useState, useEffect } from 'react';
import { useStatic } from '../context/StaticContext';

// Cache sistemi - çeviri dosyalarını tekrar yüklemek için
const translationCache = new Map();

export const useTranslation = () => {
  const { isLanguage, selectedLanguage } = useStatic();
  const [translations, setTranslations] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  // Çeviri dosyasını yükle
  const loadTranslations = async (langCode) => {
    // Cache'den kontrol et
    if (translationCache.has(langCode)) {
      setTranslations(translationCache.get(langCode));
      return;
    }

    setIsLoading(true);
    try {
      const response = await fetch(`/locales/${langCode}.json`);
      if (response.ok) {
        const data = await response.json();
        translationCache.set(langCode, data);
        setTranslations(data);
      } else {
        // Fallback olarak Türkçe yükle
        console.warn(`Translation file not found for ${langCode}, falling back to tr-TR`);
        if (!translationCache.has('tr-TR')) {
          const fallbackResponse = await fetch('/locales/tr-TR.json');
          const fallbackData = await fallbackResponse.json();
          translationCache.set('tr-TR', fallbackData);
          setTranslations(fallbackData);
        } else {
          setTranslations(translationCache.get('tr-TR'));
        }
      }
    } catch (error) {
      console.error('Error loading translations:', error);
      // Hata durumunda boş obje döndür
      setTranslations({});
    } finally {
      setIsLoading(false);
    }
  };

  // Dil değiştiğinde çevirileri yükle
  useEffect(() => {
    if (isLanguage && selectedLanguage) {
      loadTranslations(selectedLanguage);
    }
  }, [isLanguage, selectedLanguage]);

  // Nested key erişimi için helper fonksiyon
  // Örnek: t('header.welcome') -> translations.header.welcome
  const t = (key, fallback = key) => {
    if (!isLanguage || !translations) {
      return fallback;
    }

    const keys = key.split('.');
    let value = translations;

    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        return fallback;
      }
    }

    return typeof value === 'string' ? value : fallback;
  };

  // Tab için özel çeviri fonksiyonu
  const tTab = (tabKey, originalLabel) => {
    if (!isLanguage) {
      return originalLabel;
    }
    
    // Önce tabs objesinde ara
    const tabTranslation = t(`tabs.${tabKey}`);
    if (tabTranslation !== `tabs.${tabKey}`) {
      return tabTranslation;
    }
    
    // Bulamazsa categories'de ara
    const categoryTranslation = t(`categories.${tabKey}`);
    if (categoryTranslation !== `categories.${tabKey}`) {
      return categoryTranslation;
    }
    
    // Hiç bulamazsa orijinal label'ı döndür
    return originalLabel;
  };

  return {
    t,
    tTab,
    translations,
    isLoading,
    isLanguage
  };
}; 